import React from "react";

const Empty = () => {
  return <div className="empty-conversation">No conversations</div>;
};

export default Empty;
